import { createAsyncThunk } from '@reduxjs/toolkit';
import localDB, { SECONDS_IN_MINUTE } from 'lib/IndexedDB/RessourcesDB';

import { LocalesType } from 'constants/locales';
import client from 'services/networking/client';

import { DiscoveryPlaylistElements } from './types';
import { UserContext } from 'shared-types/user';

const expiration10minMS = SECONDS_IN_MINUTE * 10 * 1000;

export const fetchDiscoveryPlaylists = createAsyncThunk(
  'fetchDiscoveryRessources',
  async ({ language, userContext }: {
    language: LocalesType;
    userContext: UserContext;
  }) => {
    return await localDB.fetchOrGetData<DiscoveryPlaylistElements[]>(
      `/tags/playlists?language=${language.toLocaleUpperCase()}&userContext=${userContext}`,
      (url: string) => client.get(url),
      {},
      expiration10minMS,
    );
  },
);
